// extracted by mini-css-extract-plugin
export var menuItem = "z_tr d_fX d_bx d_bB d_bM d_bc";
export var menuItemSub = "z_ts d_X d_bx d_bM";
export var menuMainLink = "z_tt d_fY d_dy";
export var menuLink = "z_tv d_fY d_dy";
export var icon = "z_pY d_bz d_bM";
export var divider = "z_tw d_bz d_bM";
export var sublinks = "z_tx";
export var link = "z_mW";
export var Link = "z_r2 r_r2 r_rf r_rz";